module.exports = __webpack_public_path__ + "static/media/445378651_3613921035571392_2553470490740042308_n.daf539aa.jpg";